import identityConfig from '../../../../config/identity';

export default function comscore(context) {
  const siteConfig = identityConfig[context.site];

  if (siteConfig === undefined) {
    return '';
  }

  const key = '';

  return `<script type="text/javascript">
  if (typeof $igniter_var === 'undefined') {
  // Ensures that our client code is updated.
  (function(w,d,s,p,v,e,r) {w['$igniter_var']=v;w[v]=w[v]||function(){(w[v].q=w[v].q||[]).push(
  arguments)};w[v].l=1*new Date();e=d.createElement(s),r=d.getElementsByTagName(s)[0];e.async=1;
  e.src=p+'?ts='+(+new Date()/3600000|0);
  r.parentNode.insertBefore(e,r)})(window,document, 'script', '//cdn.petametrics.com/${
    key
  }.js', '$p');

  $p("init", ${key});
  $p("send", "pageview");
  }
  </script>`;
}



// WEBPACK FOOTER //
// ./src/views/components/analytics/trackers/lift_igniter.js